import React from 'react'
import {
  Icon,
  Li,
  Container,
  Subtitle,
  Text,
  Button,
  Wrapper
} from '../select-entity-item/SelectEntityItem.style'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { READER_SELECT_CLASS_PATH } from 'routes/paths'
import type { SelectClassItemProps } from './SelectClassItem.types'
import useUserPlatform from 'utils/hooks/use-platform'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'

const SelectClassItem: React.FC<SelectClassItemProps> = ({ entityName }) => {
  const { isSmallerThanTablet } = useUserPlatform()
  const { featureToggles } = useFeatureToggles()
  const hasBiblionGeneral = featureToggles?.biblionGeneral

  return (
    <Li onClick={() => (window.location.href = READER_SELECT_CLASS_PATH)}>
      <Wrapper>
        <Icon
          iconName={'school'}
          color={tokens.colors.dark5}
          size={16}
          sizeMobile={16}
        />
        <Container>
          <Subtitle color={tokens.colors.dark4}>{'Você está em:'}</Subtitle>
          <Text color={tokens.colors.dark5}>
            {hasBiblionGeneral ? 'BibliON' : entityName}
          </Text>
        </Container>
      </Wrapper>
      <Button
        theme={{
          type: 'secondary',
          size: isSmallerThanTablet ? 'small' : 'medium'
        }}
        text={hasBiblionGeneral ? 'Trocar' : 'Trocar de turma'}
        fluid
        iconName="rotate"
        isLeft
      />
    </Li>
  )
}
export default SelectClassItem
